const employeeIdentifierRules = [
  // {
  //   feedback: 'Employee ID is required',
  //   test(value) {
  //     return !!value;
  //   },
  // },
];

export default employeeIdentifierRules;
